<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.gjsc1">&nbsp;&nbsp;
        <img :src="images.gjsc2">
        <br>
        <br>
        <br>
        <img :src="images.gjsc3">&nbsp;
        <img :src="images.gjsc4">
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Finishing production line for Steel Bars</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;"
        >Recent decades, in black metal smelting boundary of the world, there are some mini metallurgy factories appeared, which is secondary operation factory relative to its small yield. Mini metallurgy factories is more vibrant and more efficiency development tendency in black metal smelting boundary. Compared to integrative big steelmaking plant, the advantage of this kind of mini factory is less cost and less influence ecological environment.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            1.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">Basic competitive edge of mini factory</span>
        <span style="font-size:12.0pt;font-family:Arial;">—</span>
        <span style="font-size:12.0pt;font-family:宋体;">Flexible, simple, compact process, suitable for the market demand, short production.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            2.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">Low investment, short construction period.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            3.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">According to different consumers, provide professional products.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            4.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">In optimizing production cost conditions, the labor productivity is much higher.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            5.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">New technology and new equipment is updated constantly.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">Mini metallurgy factory has compact design, and it has three basic process parts</span>
        <span style="font-size:12.0pt;font-family:Arial;">—</span>
        <span style="font-size:12.0pt;font-family:宋体;">electric furnace steel making, pouring and rolling.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;"> Our company could offer the turn-key service include design, equipment applying and pilot production. </span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
        <img :src="images.gjsc5" style="line-height:1.5;">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        gjsc1: require("../../../assets/img/common/gjsc1.jpg"),
        gjsc2: require("../../../assets/img/common/gjsc2.jpg"),
        gjsc3: require("../../../assets/img/common/gjsc3.jpg"),
        gjsc4: require("../../../assets/img/common/gjsc4.jpg"),
        gjsc5: require("../../../assets/img/common/gjsc5.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/gjsc.vue